<template>
  <AppLayout class="sub-page" dense>
    <section class="" v-if="userFetched">
      <slot name="top"></slot>

      <div :class="{ 'd-flex justify-center': $vuetify.breakpoint.xs }">
        <v-tabs
          color="primary"
          v-model="tab"
          :grow="$vuetify.breakpoint.xs"
          :vertical="$vuetify.breakpoint.xs"
          :centered="!$vuetify.breakpoint.xs"
        >
          <!-- <v-tabs-slider color="yellow"></v-tabs-slider> -->
          <v-tab><span v-t="'Related businesses'" /></v-tab>
          <v-tab><span v-t="'My account'" /></v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="tab" class="pt-5 bg-light">
        <v-tab-item>
          <div class="item">
            <MainTitle align="center">
              <strong><span v-t="'Related businesses'" /></strong>
            </MainTitle>
          </div>
          <UserBusiness></UserBusiness>
        </v-tab-item>
        <v-tab-item>
          <div class="item">
            <MainTitle align="center">
              <strong><span v-t="'My account'" /></strong>
            </MainTitle>
          </div>
          <UserPersonal></UserPersonal>
        </v-tab-item>
      </v-tabs-items>
    </section>
  </AppLayout>
</template>

<script>
import UserPersonal from "../../components/user/UserPersonal";
import UserBusiness from "../../components/user/UserBusiness";
import AppLayout from "@/landing/layout/AppLayout";

export default {
  components: {
    AppLayout,
    UserBusiness,
    UserPersonal,
  },
  mounted() {
    if (!this.$store.state.auth) {
      this.$router.replace({ name: "welcome" });
    } else if (this._.get(this.$route, ["query", "tab"]) === "account") {
      this.tab = 1;
    }
  },
  data() {
    return {
      tab: null,
      tabNames: ["businesses", "account"],
    };
  },
  watch: {
    tab(newValue, oldValue) {
      if ([0, 1].includes(newValue)) {
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: {
            tab: this.tabNames[newValue],
          },
        });
      }
    },
  },
  computed: {
    userFetched() {
      return this._.get(this.$store.state.user, "email");
    },
  },
};
</script>
